import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, FormTypeEdit, PageSize, PageTypeCount, PageTypeGetPaged, PaginationBack, PaginationFirst, PaginationLast, PaginationNext } from "utils/Constant";
import { ApiGetContractorList, ApiDeleteContractor } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import AddButton from "components/Button/AddButton";
import { GetStatus } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";

export default function Contractor(){
    let navigate = useNavigate()
    
    const { data: contractorList, fetch: getContractorList } = useFetch(ApiGetContractorList)
    const { fetch: deleteContractor } = useFetch(ApiDeleteContractor)

    const [contractorName, setContractorName] = useState(EmptyString)

    const contractorNameChange = (e) => {
        setContractorName(e.target.value)
    }
    const statusChange = (e) => {
        setStatus(e.value)
    }

    const [status, setStatus] = useState(DropdownStatusList[1].value)

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const addBtnClick = () => {
        navigate("/contractor-setting/form?contractorId=&formType=" + FormTypeAdd)
    }

    useEffect(() => {
        fBindGrid(0)
    },[])

    // Function Api Call
    async function fGetContractorList(index){
        let res

        await getContractorList({
            data: {
                contractorname: contractorName,
                status: status,
                pageSize: PageSize,
                pageIndex: parseInt(index),
                pageType: PageTypeGetPaged,
                sortBy: "A.ContractorName",
                sortOrder: "ASC"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return res
    }
    async function fDeleteContractor(paramContractorId, paramStatus){
        await deleteContractor({
            data: {
                contractorId: paramContractorId,
                status: paramStatus
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                            navigate("/contractor-setting")
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading({isOpen: true})

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        fGetContractorList(i).then((res) => {
            if (res !== null){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
            }
            setLoading({isOpen: false})
        })
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    // Function Button
    function fEditBtnClick(contractorId){
        navigate("/contractor-setting/form?contractorId=" + contractorId + "&formType=" + FormTypeEdit)
    }
    function fDeleteBtnClick(contractorId, status){
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading(true)

                    let stat = 1

                    if (status === 1){
                        stat = 2
                    }else if (status === 2){
                        stat = 1
                    }

                    fDeleteContractor(contractorId, stat).then(() => {
                        setLoading(false)
                        fBindGrid(pageIndex)
                    })
                }
            }
        })
    }
    function fSearchBtnClick(){
        fBindGrid(0)
    }

    function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Contractor</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row justify-between gap-4 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
                    <div className="flex flex-col gap-2 w-full sm:w-3/12 md:w-72 2xl:w-72">
                        <span>Contractor Name</span>
                        <input className="input" value={contractorName} onChange={contractorNameChange} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-2 w-full sm:w-3/12 md:w-72 2xl:w-72">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={statusChange} placeholder={"All"} />
                    </div>
                </div>
                <div>
                    <div className="flex items-end justify-end h-full">
                        <SearchButton onClick={() => { fSearchBtnClick() }} />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Contractor Name</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Address</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Bank Name</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Account Number</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Bank Name2</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Account Number 2</th>
                            <th className="font-semibold text-left px-2 hidden md:table-cell">Status</th>
                            <th className="font-semibold w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {contractorList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.contractorName }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.address }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.bankName }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.accountNumber }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.bankName2 }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.accountNumber2 }</span>
                                    </td>
                                    <td className="px-2 hidden md:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex justify-center py-2 gap-2 px-2">
                                        <button className={`button flex gap-2`} onClick={() => fEditBtnClick(data.contractorId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === 1 ? 'block' : 'hidden' }`} onClick={() => fDeleteBtnClick(data.contractorId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === 1 ? 'hidden' : 'block' }`} onClick={() => fDeleteBtnClick(data.contractorId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}